import * as React from 'react';
import * as styles from './styles.scss';
import { AccountType, SystemType, TransferType } from 'constants/enum';

import { Fallback } from 'components/common';
import { ToastType } from 'react-toastify';

import {
  IDerCashTransferParams,
  IParamsDoInternalTransfer,
} from 'interfaces/api';
import { IState } from 'redux/global-reducers';
import { WithNamespaces, withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { doCashTransfer, doDerivativeInternalCashTransfer } from '../action';
import { handleError } from 'utils/common';
import {
  queryDerivativeTransferableAmount,
  queryTransferableAmount,
  showNotification,
} from 'redux/global-actions';
import { querySubAccount } from './action';
import { withErrorBoundary } from 'react-error-boundary';
import { IDropdownData } from '../Common/Beneficiary';
import BenificiaryNew from '../Common/BeneficiaryNew';
import SendingAccountNew from '../Common/SendingAccountNew';
import { CashTransferTabs } from '../enum';
import { Button } from 'react-bootstrap';
import { getAssetInformation } from '../../AssetInformation/AssetInforEquity/actions';
import CashTransferConfirmForm from '../Common/CashTransferConfirmForm';
import { debounce } from 'utils/delay';
import { getKey } from 'utils/localStorage';
import { DEVICEID } from 'constants/main';

export interface ICashTransferInternalSubProps
  extends React.ClassAttributes<CashTransferInternalSubComponent>,
    WithNamespaces {
  readonly selectedAccount: IState['selectedAccount'];
  readonly equityTransferableAmount: IState['equityTransferableAmount'];
  readonly equitySubAccount: IState['equitySubAccount'];
  readonly derivativeTransferableAmount: IState['derivativeTransferableAmount'];
  readonly equityCashTransferResult: IState['equityCashTransferResult'];
  readonly derivativeInternalCashTransferResult: IState['derivativeInternalCashTransferResult'];
  readonly accountList: IState['accountList'];
  readonly assetInformation: IState['assetInformation'];
  readonly queryTransferableAmount: typeof queryTransferableAmount;
  readonly queryDerivativeTransferableAmount: typeof queryDerivativeTransferableAmount;
  readonly querySubAccount: typeof querySubAccount;
  readonly doCashTransfer: typeof doCashTransfer;
  readonly doDerivativeInternalCashTransfer: typeof doDerivativeInternalCashTransfer;
  readonly getAssetInformation: typeof getAssetInformation;
  readonly showNotification: typeof showNotification;

  readonly onSelectVSD: (bank: boolean, VSD: boolean) => void;
  readonly onSelect?: (activeKey: string) => void;
}

export interface ICashTransferInternalSubState {
  readonly transferAmount: number;
  readonly advanceAmount: number;
  readonly beneficiaryAccountNo: string;
  readonly content: string;
  readonly openPopup: boolean;
  readonly activeStep: number;
  readonly fee: number;
  readonly macAddress?: string;
}
class CashTransferInternalSubComponent extends React.Component<
  ICashTransferInternalSubProps,
  ICashTransferInternalSubState
> {
  private localAccountData: IDropdownData[] | [] = [];
  private localIsDerivatives: boolean;
  private listStep = [
    { step: 1, title: 'Create request' },
    { step: 2, title: 'Confirm' },
  ];

  constructor(props: ICashTransferInternalSubProps) {
    super(props);
    this.state = {
      transferAmount: 0,
      advanceAmount: 0,
      beneficiaryAccountNo: '',
      content: '',
      openPopup: false,
      activeStep: 0,
      fee: 0,
      macAddress: getKey(DEVICEID) ?? '',
    };
  }

  componentDidMount() {
    this.props.onSelectVSD(false, false);
    this.localIsDerivatives =
      this.props.selectedAccount?.type === SystemType.DERIVATIVES;
    this.queryTransferableAmount(this.props.selectedAccount?.account);
    this.props.querySubAccount({
      clientID: this.props.selectedAccount?.username,
    });
    if (this.props.selectedAccount != null && !this.localIsDerivatives) {
      this.props.getAssetInformation({
        accountNumber: this.props.selectedAccount.accountNumber,
      });
    }
  }

  shouldComponentUpdate(nextProps: ICashTransferInternalSubProps) {
    if (
      nextProps.equitySubAccount.data &&
      nextProps.equitySubAccount.data !== this.props.equitySubAccount.data
    ) {
      const defaultSubAccount = nextProps.equitySubAccount.data.find(
        (subAccount) => subAccount.defaultSubAccount
      );
      const derivativeAccount = nextProps.accountList.find(
        (account) => account.accountType === AccountType.DERIVATIVES
      );
      this.localAccountData = nextProps.equitySubAccount.data
        .filter((account) => {
          if (this.localIsDerivatives) {
            return account.defaultSubAccount;
          }
          return defaultSubAccount?.subAccountID ===
            nextProps.selectedAccount?.account
            ? account.subAccountID !== nextProps.selectedAccount?.account
            : account.subAccountID !== nextProps.selectedAccount?.account &&
                account.subAccountID !== derivativeAccount?.account;
        })
        .map((account) => {
          return { title: account.subAccountID, value: account.subAccountID };
        });
    }

    if (this.props.selectedAccount !== nextProps.selectedAccount) {
      this.localIsDerivatives =
        nextProps.selectedAccount?.type === SystemType.DERIVATIVES;
      this.props.querySubAccount({
        clientID: nextProps.selectedAccount?.username,
      });
      this.queryTransferableAmount(nextProps.selectedAccount?.account);
      if (nextProps.selectedAccount != null && !this.localIsDerivatives) {
        this.props.getAssetInformation({
          accountNumber: nextProps.selectedAccount.accountNumber,
        });
      }
    }

    if (
      (this.props.derivativeInternalCashTransferResult !==
        nextProps.derivativeInternalCashTransferResult &&
        nextProps.derivativeInternalCashTransferResult.status.isSucceeded) ||
      (this.props.equityCashTransferResult !==
        nextProps.equityCashTransferResult &&
        nextProps.equityCashTransferResult.status.isSucceeded)
    ) {
      this.queryTransferableAmount(nextProps.selectedAccount?.account);
      this.props.onSelect?.(CashTransferTabs.HistoryCashInternal);
    }
    return true;
  }

  render() {
    const { t } = this.props;
    return (
      <>
        <div className={styles.progressStep}>
          {this.listStep.map((step: any, index) => {
            return (
              <div
                key={step.step}
                style={{
                  fontWeight: 500,
                  color: this.state.activeStep >= index ? '#fff' : '#3B4257',
                }}
              >
                <Button
                  className={
                    this.state.activeStep >= index
                      ? styles.active
                      : styles.StepNumber
                  }
                >
                  {step.step}
                </Button>
                <div className={styles.StepTitle}>{t(step.title)}</div>
              </div>
            );
          })}
        </div>

        <div
          className={styles.CashTransferInternalContent}
          style={{
            display: this.state.activeStep === 0 ? 'flex' : 'none',
          }}
        >
          <SendingAccountNew
            transferAmount={
              this.localIsDerivatives
                ? this.props.derivativeTransferableAmount.data
                    ?.transferableAmountToInternalSubsOrToBank
                : this.props.equityTransferableAmount.data?.transferableAmount
            }
            accountBalance={this.props.equityTransferableAmount.data}
          />
          <BenificiaryNew
            transferableAmount={
              this.localIsDerivatives
                ? this.props.derivativeTransferableAmount.data
                    ?.transferableAmountToInternalSubsOrToBank
                : this.props.equityTransferableAmount.data?.transferableAmount
            }
            modalTitle={'Transfer cash to internal sub account'}
            accountData={this.localAccountData}
            onChangeTransferAmount={this.onChangeTransferAmount}
            onChangeAdvanceAmount={this.onChangeAdvanceAmount}
            transferAmount={this.state.transferAmount}
            onConfirm={this.onConfirmTransfer}
            onChangeContent={this.onChangeContent}
            onChangeBeneficiaryAccount={this.onChangeBeneficiaryAccount}
            onReset={this.onReset}
            content={this.state.content}
            onChangeStep={this.onChangeStep}
            currentStep={this.state.activeStep}
            accountBalance={this.props.assetInformation.data?.marginCallBy}
            onChangeFee={this.onChangeFee}
          />
        </div>

        {this.state.activeStep === 1 && (
          <CashTransferConfirmForm
            titleHeader="Confirm internal cash transfer information"
            transferAmount={this.state.transferAmount}
            advanceAmount={
              this.props.equityTransferableAmount.data?.mvRequiredAdvAmt
            }
            content={this.state.content}
            fee={this.state.fee}
            selectedAccount={this.props.selectedAccount}
            beneficiaryAccountNo={this.state.beneficiaryAccountNo}
            onChangeStep={this.onChangeStep}
          />
        )}
      </>
    );
  }

  private onChangeFee = (fee: number) => {
    this.setState({ fee });
  };

  private onChangeStep = (step: number) => {
    this.setState({ activeStep: step });
  };

  private onHideModal = () => {
    this.setState({ openPopup: false });
  };

  private onChangeBeneficiaryAccount = (value: string) => {
    this.setState({ beneficiaryAccountNo: value });
  };

  private onChangeContent = (value: string) => {
    this.setState({ content: value });
  };

  private onChangeTransferAmount = debounce((value: number) => {
    this.setState({ transferAmount: Number(value) });
    this.queryTransferableAmountAndWaitingCash(value);
  }, 1000);

  private onChangeAdvanceAmount = (value: number) => {
    this.setState({ advanceAmount: value });
    // handle debounce to caculator fee advanceAmount here
  };

  private queryTransferableAmountAndWaitingCash = (value: number) => {
    if (this.localIsDerivatives) {
      this.props.queryDerivativeTransferableAmount({
        accountNo: this.props.selectedAccount?.account,
        withdrawAmt: `${value}`,
      });
    } else {
      this.props.queryTransferableAmount({
        accountNo: this.props.selectedAccount?.account,
        withdrawAmt: `${value ?? 0}`,
      });
    }
  };

  private onReset = () => {
    this.setState({ transferAmount: 0, beneficiaryAccountNo: '', content: '' });
  };

  private queryTransferableAmount = (accountNo?: string) => {
    if (this.localIsDerivatives) {
      this.props.queryDerivativeTransferableAmount({ accountNo });
    } else {
      this.props.queryTransferableAmount({ accountNo });
    }
  };

  private onConfirmTransfer = (otpToken?: string) => {
    if (otpToken == null) {
      this.props.showNotification({
        type: ToastType.ERROR,
        title: 'Cash Transfer',
        content: 'Token is invalid',
        time: new Date(),
      });
      return;
    }

    this.doCallCashTransfer(otpToken);
  };

  private doCallCashTransfer = (otpToken?: string) => {
    const beneficiaryAccount = this.props.accountList?.find(
      (account) => account.account === this.state.beneficiaryAccountNo
    );
    const isTransferToDer =
      beneficiaryAccount?.accountType === AccountType.DERIVATIVES;
    if (this.localIsDerivatives || isTransferToDer) {
      const param: IDerCashTransferParams = {
        accountNumber: isTransferToDer
          ? this.state.beneficiaryAccountNo
          : this.props.selectedAccount?.account,
        transferType: isTransferToDer
          ? TransferType.EQT_TO_DR
          : TransferType.DR_TO_EQT,
        transferAmount: this.state.transferAmount,
        transferableAmount: isTransferToDer
          ? this.props.equityTransferableAmount.data?.transferableAmount
          : this.props.derivativeTransferableAmount.data
              ?.transferableAmountToInternalSubsOrToBank,
        content: this.state.content,
        otpToken,
        macAddress: this.state.macAddress,
      };
      this.props.doDerivativeInternalCashTransfer(param);
    } else {
      const param: IParamsDoInternalTransfer = {
        transferType: TransferType.TO_SUB,
        senderAccountNo: this.props.selectedAccount?.account,
        senderFullName: this.props.selectedAccount?.accountName,
        transferableAmount: this.props.equityTransferableAmount.data
          ?.transferableAmount,
        beneficiaryAccountNo: this.state.beneficiaryAccountNo,
        beneficiaryFullName: this.props.selectedAccount?.accountName,
        transferAmount: this.state.transferAmount,
        content: this.state.content,
        transferFee: 0,
        otpToken,
        macAddress: this.state.macAddress,
      };
      this.props.doCashTransfer(param);
    }
    this.onHideModal();
  };
}

const mapStateToProps = (state: IState) => ({
  selectedAccount: state.selectedAccount,
  equityTransferableAmount: state.equityTransferableAmount,
  equitySubAccount: state.equitySubAccount,
  accountList: state.accountList,
  derivativeTransferableAmount: state.derivativeTransferableAmount,
  equityCashTransferResult: state.equityCashTransferResult,
  derivativeInternalCashTransferResult:
    state.derivativeInternalCashTransferResult,
  assetInformation: state.assetInformation,
});

const mapDispatchToProps = {
  queryTransferableAmount,
  queryDerivativeTransferableAmount,
  querySubAccount,
  doCashTransfer,
  doDerivativeInternalCashTransfer,
  getAssetInformation,
  showNotification,
};

const CashTransferInternalSub = withErrorBoundary(
  withNamespaces('common')(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(CashTransferInternalSubComponent)
  ),
  Fallback,
  handleError
);

export default CashTransferInternalSub;



// WEBPACK FOOTER //
// ./src/components/areas/Account/CashTransfer1/CashTransferInternalSub/index.tsx